module.exports = __webpack_public_path__ + "img/Solidarity.95ed3595.jpg";